import { ACHIEVEMENTS } from '../../lib/idle/gameConfig';
import { useIdle } from '../../lib/idle/idleStore';
import Styles from './Achievements.module.css';

const Achievements = () => {
  const state = useIdle();
  const earned = ACHIEVEMENTS.filter((a) => a.test(state)).length;
  const percent = ACHIEVEMENTS.length ? (earned / ACHIEVEMENTS.length) * 100 : 0;

  return (
    <main className={Styles.page}>
      <div className={Styles.column}>
        <h1 className={Styles.title}>Achievements</h1>
        <p className={Styles.sub}>
          {earned} of {ACHIEVEMENTS.length} earned
        </p>
        <div
          className={Styles.progress}
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={ACHIEVEMENTS.length}
          aria-valuenow={earned}
        >
          <div className={Styles.progressFill} style={{ width: `${percent}%` }} />
        </div>

        <ul className={Styles.grid}>
          {ACHIEVEMENTS.map((a) => {
            const got = a.test(state);
            return (
              <li key={a.id} className={`${Styles.card} ${got ? Styles.cardGot : ''}`}>
                <span className={Styles.stamp} aria-hidden="true">
                  {got ? '★' : '?'}
                </span>
                <span className={Styles.name}>{got ? a.name : '???'}</span>
                <span className={Styles.desc}>{a.desc}</span>
                <span className={Styles.sr}>{got ? 'Earned' : 'Not earned yet'}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </main>
  );
};

export default Achievements;